import * as constants from '@config/constants';
const initialState = {
  data: {},
  // data: fixture
};

const reducer = (state = initialState, action) => {
  const { data } = action;
  switch (action.type) {
    case constants.VERIFY_SUBMIT:
      return { ...state, data };
    case constants.VERIFY_SET_HISTORY:
      return {
        ...state,
        history: data,
      };
    default:
      return state;
  }
};

export default reducer;
